/**
 * EventVendorRegistrationService
 * Service for managing event vendor registrations
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for event vendor registration CRUD operations
 */
export class EventVendorRegistrationService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? EventVendorRegistrationService.DEFAULT_SERVICE_PATH,
            basePath: EventVendorRegistrationService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all registration views with enriched vendor details
     * @returns Array of registration model views
     */
    async getViews() {
        const response = await this.getViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all registration views with full response
     * @returns ResponseData with array of registration model views
     */
    getViewsRaw() {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    /**
     * Get registration views for a specific event
     * @param eventId - Event ID to filter by
     * @returns Array of registration model views for the event
     */
    async getViewsByEventId(eventId) {
        const response = await this.getViewsByEventIdRaw(eventId);
        return response.data ?? [];
    }
    /**
     * Get registration views for a specific event with full response
     * @param eventId - Event ID to filter by
     * @returns ResponseData with array of registration model views
     */
    getViewsByEventIdRaw(eventId) {
        const url = this.buildUrl(`event/${eventId}/views`);
        return this.http.get(url);
    }
    /**
     * Get a single registration view by ID
     * @param id - Registration ID
     * @returns Registration model view
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`EventVendorRegistration view with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get a single registration view by ID with full response
     * @param id - Registration ID
     * @returns ResponseData with registration model view
     */
    getViewRaw(id) {
        const url = this.buildUrl(`${id}/view`);
        return this.http.get(url);
    }
}
EventVendorRegistrationService.DEFAULT_SERVICE_PATH = 'events';
EventVendorRegistrationService.BASE_PATH = 'api/event-vendor-registrations';
//# sourceMappingURL=EventVendorRegistrationService.js.map